module.exports = __webpack_public_path__ + "static/media/jam_pasir.7651e3f2.png";